export default "__VITE_ASSET__6dc1651d__"